import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function modalOpenUnsavedUserDataReducer(state = initialState.isUnsavedUserDataModalOpen, action) {
	switch (action.type) {
		case types.SET_IS_UNSAVED_USER_DATA: {
			return action.isUnsavedUserDataModalOpen;
		}
		case types.CLEAR_ADMIN_USER: {
			return initialState.isUnsavedUserDataModalOpen;
		}
		default:
			return state;
	}
}
